import { securedAxiosInstance } from "../axios";

class IbanService {
  updateCustomerIban(formData) {
    return securedAxiosInstance.put("/iban", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  }

  confirmCustomerIban(customerId) {
    return securedAxiosInstance.post("/iban/confirm", { customer_id: customerId });
  }

  extractIban(formData) {
    return securedAxiosInstance.post("/iban/extract", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  }
}

export default new IbanService();
